import React, { useState, useRef} from 'react';
import { Box } from "@mui/material";
import SharedRequestsGrid from './SharedRequestsGrid';
import SharedRequestsHeaderActions from './SharedRequestsHeaderActions';
import { useAuth } from '../../components/auth/AuthProvider';
import { Share } from '@mui/icons-material';

const SharedRequests = () => {
    const { user, role } = useAuth();
    const [searchText, setSearchText] = useState('');
    const tableRef = useRef(null);

    const handleOpenColumns = () => {
        tableRef.current?.openColumnsPanel();
    };

    const handleOpenFilters = () => {
        tableRef.current?.openFiltersPanel();
    };

     const handleStatus = (event) => {
        console.log("handleStatus ..::> ", event);
        // setReportGridFilter
        event ? tableRef.current?.setReportGridFilter(event) : tableRef.current?.clearStatusFilter();
    }
    
    if (user === undefined) {
        return <div>Loading...</div>;
    }

    return (
            <Box>
                <SharedRequestsHeaderActions
                    searchText={searchText}
                    onSearchChange={setSearchText}
                    onOpenColumns={handleOpenColumns}
                    onOpenFilters={handleOpenFilters}
                    onHandleStatus={handleStatus}
                    isStatusFilterActive={true}
                />
    
                <SharedRequestsGrid 
                    tableRef={tableRef}
                    searchText={searchText}
                    isStatusColumn={false}
                />;
            </Box>
        )
}

export default SharedRequests